import { call, select } from "redux-saga/effects";
import { WEEKDAYS } from "lib/date";

import {
  getDinnerBookingByID,
  getDinnerBookingIDList
} from "state/school_money/selectors";

import BasketItemIssue from "state/school_money/entities/BasketItemIssue";

/**
 * Check for issues with the given basket item.
 * Returns zero or one issues.
 *
 * @param {BasketItem} basketItem
 * @returns {BasketItemIssue | undefined}
 */
export default function* validateBasketItem(basketItem) {
  
  const dinnerBookingID = basketItem.payload.get("dinnerBookingID");

  if (yield call(isExpired, dinnerBookingID)) {
    return BasketItemIssue.fromBasketItem(basketItem, "expired");
  }
  
  // get version in basket and version in state to compare
  const newDinnerBooking = yield select(getDinnerBookingByID, dinnerBookingID);
  const oldDinnerBooking = basketItem.getIn(["payload", "dinnerBooking"]);
  
  if (areDaysExpired(newDinnerBooking, oldDinnerBooking)) {
    return BasketItemIssue.fromBasketItem(basketItem, "expired");
  }
  
  if (haveBookingsChanged(newDinnerBooking, oldDinnerBooking)) {
    return BasketItemIssue.fromBasketItem(basketItem, "bookings_changed");
  }

}

/**
 * Has the dinner booking disappeared form state?
 * @returns {boolean}
 */
function* isExpired(dinnerBookingID) {
  const dinnerBookingIDList = yield select(getDinnerBookingIDList);
  return !dinnerBookingIDList.includes(dinnerBookingID);
}

/**
 * Have any of the days in this dinner booking expired since it was added?
 * @returns {boolean}
 */
function areDaysExpired(newDinnerBooking, oldDinnerBooking) {
  
  // check weekdays individually
  for (let i = 0; i < WEEKDAYS.length; i++) {
    
    // get old and new values for whether this day is expired
    const newIsExpired = newDinnerBooking.expired.get(i);
    const oldIsExpired = oldDinnerBooking.getIn(["expired", i]);
    
    if (newIsExpired && !oldIsExpired) {
      return true;
    }
    
  }
  
  return false;
  
}

/**
 * Have any of the bookings in this dinner changed since it was added?
 * @returns {boolean}
 */
function haveBookingsChanged(newDinnerBooking, oldDinnerBooking) {
  
  for (let i = 0; i < WEEKDAYS.length; i++) {
    
    const newBookedOption = newDinnerBooking.bookedOptions.get(i);
    const oldBookedOption = oldDinnerBooking.getIn(["bookedOptions", i]);
    
    if (!newBookedOption || !newBookedOption.equals(oldBookedOption)) {
      return true;
    }
  }
  
  return false;
  
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/basketSaga/dinnerBooking/validateBasketItem.js